import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import {
  TimelineUnassignedServiceIdsQueryParamKey,
  TimelineUnassignedServiceSearchesQueryParamKey,
} from '@wilson/interfaces';
import {
  SetUnassignedServiceIdsFilter,
  SetUnassignedServiceSearchesFilter,
} from '@wilson/shift-timeline/state';
import { DateTimeFormat } from '@wilson/utils';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { isUUIDLike } from '@wilson/utils';

@Component({
  selector: 'wilson-unassigned-region-activity-search-filter',
  imports: [NzSelectModule, FormsModule, TranslateModule],
  templateUrl: './unassigned-region-activity-search-filter.component.html',
  styleUrls: ['./unassigned-region-activity-search-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnassignedRegionActivitySearchFilterComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly store = inject(Store);

  @Input({ required: true }) unassignedServices!:
    | { id: string; name: string }[]
    | null;
  @Input({ required: true }) resourcesColumnWidthPx!: number | null;

  selectedUnassignedFilter: string[] = [];
  protected DateTimeFormat = DateTimeFormat;

  ngOnInit(): void {
    const queryParams = this.activatedRoute.snapshot.queryParams;
    const unassignedServiceIdsQueryParams: string =
      queryParams[TimelineUnassignedServiceIdsQueryParamKey];
    const unassignedServiceSearchesQueryParams: string =
      queryParams[TimelineUnassignedServiceSearchesQueryParamKey];

    const unassignedServiceIds = unassignedServiceIdsQueryParams
      ? unassignedServiceIdsQueryParams.split(',')
      : [];
    const unassignedServiceSearches = unassignedServiceSearchesQueryParams
      ? unassignedServiceSearchesQueryParams.split(',')
      : [];
    this.selectedUnassignedFilter = [
      ...unassignedServiceIds,
      ...unassignedServiceSearches,
    ];
    this.dispatchSetFilterActions(
      unassignedServiceIds,
      unassignedServiceSearches,
    );
  }

  public setUnassignedServicesFilter(selectedFilters: string[]) {
    const unassignedServiceIds: string[] = [];
    const unassignedServiceSearches: string[] = [];

    selectedFilters.forEach((filter) => {
      if (isUUIDLike(filter)) {
        unassignedServiceIds.push(filter);
      } else {
        unassignedServiceSearches.push(filter);
      }
    });
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: {
        [TimelineUnassignedServiceIdsQueryParamKey]: unassignedServiceIds.length
          ? unassignedServiceIds.join(',')
          : null,
        [TimelineUnassignedServiceSearchesQueryParamKey]:
          unassignedServiceSearches.length
            ? unassignedServiceSearches.join(',')
            : null,
      },
      queryParamsHandling: 'merge',
    });
    this.dispatchSetFilterActions(
      unassignedServiceIds,
      unassignedServiceSearches,
    );
  }

  private dispatchSetFilterActions(
    unassignedServiceIds: string[],
    unassignedServiceSearches: string[],
  ) {
    this.store.dispatch(
      new SetUnassignedServiceIdsFilter(unassignedServiceIds),
    );
    this.store.dispatch(
      new SetUnassignedServiceSearchesFilter(unassignedServiceSearches),
    );
  }
}
